export default {
  basp: {
    orderNumber: 'Nomor Pesanan',
    shipmentGroupNo: 'Nomor Kiriman',
    orderDate: 'Tanggal Pesanan',
    pickupDate: 'Tanggal Pickup',
    customer: 'Customer',
    transporter: 'Transporter',
    podDate: 'Tanggal POD',
    shipmentStatus: 'Status Penerimaan',
    baspReason: 'Alasan Selisih',
    itemNote: 'Keterangan Item',
    shipperAction: 'Action Plan Shipper',
    baspNote: 'Keterangan BASP',
    inputOrderNumber: 'Masukkan Nomor Pesanan', shipmentNo: 'Nomor Pesanan'
  },
  customer: {
    name: 'Nama Customer',
    pic: 'Penanggung Jawab (PIC)',
    address: 'Alamat',
    phone: 'Nomor Telepon',
    originLocation: 'Lokasi Asal',
    destinationLocation: 'Lokasi Tujuan',
    contractDate: 'Tanggal Kontrak',
    inputCustomerName: 'Masukkan Nama Customer',
  },
  rating: {
    nameTransporter: 'Nama Transporter',
    averageRating: 'Rata - Rata Rating',
    inputTransporterName: 'Masukkan Nama Transporter',
    vehicleName: 'Nama Kendaraan',
    vehiclePlat: 'Plat Nomor Kendaraan',
    vehicleRating: 'Rating Kendaraan',
    driverName: 'Nama Sopir',
    driverPhone: 'Nomor Telepon',
    driverRating: 'Rating Sopir',
    inputVehiclePlat: 'Masukkan Plat Nomor Kendaraan',
    inputDriverName: 'Masukkan Nama Sopir',
    orderRating: 'Rating Pesanan',
  },
  footer: {
    listTransporter: 'Daftar Transporter',
    listVehicle: 'Daftar Kendaraan',
    listOrder: 'Daftar Pesanan'
  }
}
